import { CLIENT_TYPES } from "../api/clientconfig";


const clientFlagMap = {
  from_doktor: CLIENT_TYPES.DOKTOR_CONNECT,
  from_atp: CLIENT_TYPES.ATP,
  from_hellohealth: CLIENT_TYPES.HELLO_HEALTH,
  // Add more mappings as needed
};

export const identifyClientType = () => {
  for (const key in clientFlagMap) {
    const value = window.localStorage.getItem(key);
    if (value === 'true') {
      return clientFlagMap[key];
    }
  }
  return CLIENT_TYPES.DEFAULT;
};